module.exports = __webpack_public_path__ + "img/weddings.7cd0e3ad.jpg";